import PropTypes from 'prop-types';
import React, { useRef, Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeading from '@/@communityshare/ui/PageHeading';
import PaginationNew from '@/components/pagination-new/Pagination';
import PaginationInformation from '@/components/pagination-new/PaginationInformation';
import useScrollToTop from '@/hooks/useScrollToTop';
import Results from './Results';
import SortBy from '@/pages/evaluations-event-partners/SortBy';
import FilterButton from '@/pages/_common_filters/FilterButton';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import useDialogConfig from '@hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import { DialogManager } from '@/dialogs_new/DialogManager';
import queryString from 'query-string';
import useFilterCount from '@/hooks/useFilterCount';
import _ from 'lodash';
import { attributeKeys } from '@/pages/evaluations-event-partners/queryUtils';
import MobileNavigation from '@/pages/evaluations/MobileNavigation';

export default function Layout(props) {
  const {
    location,
    extra,
    breadcrumbs,
    title,
    description,
    result,
    pageSize,
    row,
    render
  } = props;

  const node = useRef();
  const scrollToTop = useScrollToTop();

  const search = queryString.parse(location?.search);
  const filterCount = useFilterCount(search, _.filter(attributeKeys, key => [
    'networks'
  ].indexOf(key) < 0));

  const launch = useDialogLauncher();
  const config = useDialogConfig();

  function showFilters() {
    launch(DialogManager.FiltersEvaluationEventPartner.Config(config?.id, extra));
  }

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Partner Event Evaluations: {title}</title>
      </Helmet>
      <MobileNavigation />
      <PageHeading
        breadcrumbs={breadcrumbs}
        title={title}
        description={description}
      />
      <>
        <div ref={node} className="flex flex-wrap gap-4 justify-between items-end">
          <PaginationInformation
            pageSize={pageSize}
            totalCount={result.meta?.totalCount}
          />
          {/*<PaginationNew*/}
          {/*  pageSize={pageSize}*/}
          {/*  totalCount={result.meta?.totalCount}*/}
          {/*  onNavigate={() => scrollToTop(node)}*/}
          {/*/>*/}
          {location && (
            <div className="flex flex-wrap gap-4">
              <SortBy/>
              <FilterButton
                count={filterCount}
                onClick={showFilters}
              />
            </div>
          )}
        </div>
        {/*<div ref={node} className="flex justify-between">*/}
        {/*  <div className="flex space-x-4">*/}
        {/*    <NetworkFilter/>*/}
        {/*    <TypeFilter/>*/}
        {/*    <DistanceFilter/>*/}
        {/*  </div>*/}
        {/*  <div className="flex space-x-4">*/}
        {/*    <SortBy/>*/}
        {/*    <FilterButton*/}
        {/*      count={filterCount}*/}
        {/*      onClick={showFilters}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</div>*/}
        {render ? render : (
          <Results
            result={result}
            row={row}
          />
        )}
        <div className="flex flex-wrap gap-4 items-center justify-between">
          <PaginationInformation
            pageSize={pageSize}
            totalCount={result.meta?.totalCount}
          />
          <PaginationNew
            pageSize={pageSize}
            totalCount={result.meta?.totalCount}
            onNavigate={() => scrollToTop(node)}
          />
        </div>
      </>
    </div>
  );
}

Layout.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  extra: PropTypes.shape({}),
  breadcrumbs: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  description: PropTypes.node,
  result: PropTypes.shape({
    meta: PropTypes.shape({
      totalCount: PropTypes.number
    })
  }),
  pageSize: PropTypes.number,
  row: PropTypes.func,
  render: PropTypes.node,
  filterDialog: PropTypes.shape({})
};
